const setFileExtension = (name, extension) => {
  const pos = name.lastIndexOf(".");
  const ext = extension.replace(".", "");
  return `${name.substring(0, pos < 0 ? name.length : pos)}.${ext}`;
};

export default setFileExtension;
